import React from 'react';
import { View } from "../native";
import Collapsible from "../Collapsible";
import Icon from "../Icon";
import wrapComponent from "../../core/wrapComponent";
import { useStateWithCallback } from "../../hooks";
const DEFAULTS = {
  renderChildren: () => null
};

const defaultLeft = ({
  noChild,
  onPress,
  collapsed
}) => /*#__PURE__*/React.createElement(View, {
  style: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center'
  }
}, /*#__PURE__*/React.createElement(Icon, {
  name: noChild ? 'circle' : collapsed ? 'chevron-down' : 'chevron-up',
  size: noChild ? 7 : 22,
  onPress: onPress,
  disabled: noChild
}));

const defaultRight = () => null;

function ElementWrapper(props) {
  const {
    children,
    level,
    renderChildren = DEFAULTS.renderChildren,
    noChild,
    left = defaultLeft,
    right = defaultRight
  } = props;
  const [state, setState] = useStateWithCallback({
    collapsed: true
  });
  const onPress = React.useCallback(() => {
    setState({
      collapsed: !state.collapsed
    });
  }, [setState, state.collapsed]);
  return /*#__PURE__*/React.createElement(View, {
    style: {
      width: '100%',
      flexDirection: 'row',
      paddingLeft: 5 * level // opacity: noChild ? 0.8 : 1,

    }
  }, left({
    collapsed: state.collapsed,
    noChild,
    onPress,
    level
  }), /*#__PURE__*/React.createElement(View, {
    style: {
      justifyContent: 'center',
      flex: 1
    }
  }, children, /*#__PURE__*/React.createElement(Collapsible, {
    collapsed: state.collapsed
  }, renderChildren())), right({
    collapsed: state.collapsed,
    noChild,
    onPress,
    level
  }));
}

export default wrapComponent(ElementWrapper, {});